export default {
  noc: {
    buttons: {
      support: 'Support',
      issueList: 'Issue list',
      installationList: 'Installation list',
      callHistory: 'Call history',
      missionList: 'Missions list',
      tasks: 'Tasks',
    },
    calls: {
      addRecord: 'Add call record',
      editRecord: 'Edit call record',
      reasonTitle: 'Reason of call',
      reasonPlaceholder: 'Select reason of call',
      noteTitle: 'Note',
      dateTitle: 'Date',
      submit: 'Save',
      deleteTitle: 'Delete call record',
      deleteDescription: 'Are you sure you want to delete this call record?',
      deleteConfirm: 'Delete',
      deleteCancel: 'Cancel',
    },
      missions: {
      title: 'Mission list',
      addMission: 'Add mission',
      editMission: 'Edit mission',
      emptyToday: 'No missions assigned today',
      fields: {
        date: 'Date',
        user: 'Employee',
        missionType: 'Type of mission',
        status: 'Status',
        location: 'Location',
        customerName: 'Customer name',
        equipment: 'Used equipment',
        note: 'Note',
        cost: 'Travel cost',
      },
      statusOptions: {
        pending: 'Pending',
        inProgress: 'In progress',
        done: 'Done',
      },
      typeOptions: {
        installation: 'Installation',
        troubleshooting: 'Troubleshooting',
        siteSurvey: 'Site survey',
        other: 'Other',
      },
      actions: {
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
      },
      deleteTitle: 'Delete mission',
      deleteDescription: 'Are you sure you want to delete this mission?',
    },
    cards: {
      tasks: {
        title: 'Transmission and mission tasks',
      },
      equipment: {
        title: 'Used equipment widget',
        empty: 'No equipment used today',
      },
      calls: {
        title: 'Call history widget',
        totalCalls: 'Total calls',
        technicalIssue: 'Technical issue',
        recharge: 'Recharge',
        disconnect: 'Disconnection',
        other: 'Other',
      },
      todayInstallations: {
        title: "Today''s installations",
        installed: 'Installed',
        canceled: 'Canceled',
        postponed: 'Postponed',
        issuesTitle: 'Resolved problems',
        solved: 'Solved',
        deferred: 'Deferred',
        unsolved: 'Unsolved',
      },
      teamActivity: {
        title: 'Team activity',
        calls: 'Calls',
        tickets: 'Tickets',
        installations: 'Installations',
      },
    },
    defaultTitle: 'Dashboard',
    defaultMessage: 'This dashboard layout is not yet customized for your role.',
  },
}
